import React, { useState } from "react";
import firebase from "firebase";
import "firebase/functions";
import { Helmet } from "react-helmet";
import DivorceForm from "../Features/DivorceAssess/divorceForm";

function DivorceAssess() {
  const [loading, setLoading] = useState(false);

  // const getPrice = async () => {
  //   try {
  //     setLoading(true);
  //     const calcPrice = firebase.functions().httpsCallable("calcPrice");
  //     const response = await calcPrice(intialValues);

  //     setTimeout(() => setLoading(false), 3000);
  //   } catch (e) {
  //     console.log("error occurred", e);
  //   }
  // };
  return (
    <div>
      <Helmet>
        <title>Resolvy - Free Divorce Online Asessment</title>
        <meta name="title" content="Resolvy Divorce Assessment" />
        <meta
          name="description"
          content="Find out for free if you qualify for a divorce, the process and cost. Resolvy helps you divorce easier."
        />
      </Helmet>
      {loading && <p>loading....</p>}
      <DivorceForm />
    </div>
  );
}

export default DivorceAssess;
